module.exports = __webpack_public_path__ + "src/assets/img/fail@2x.d182fcd6.png";